<app-header [activeLink]="0"></app-header>

<div class="dashboard-container">
  <!-- Main Content -->
  <main class="dashboard-main">
    <!-- Main Top Layout Section -->
    <div class="home-top-section">
      <!-- Left Column: Greeting Banner + News Section -->
      <div class="home-left-column">
        <!-- Dynamic Greeting Banner -->
        <div class="greeting-banner" [class]="'greeting-banner theme-' + greetingTheme">
          <!-- Ambient Effects Container -->
          <div class="banner-ambient-effects">
            <!-- Morning Mist / Clouds / Sun Rays -->
            @if (greetingTheme === 'morning') {
            <div class="morning-mist"></div>
            <div class="sun-rays"></div>
            <svg class="morning-bird bird-1" viewBox="0 0 30 50">
              <g class="bird-body-group">
                <path class="left-wing" d="M 15 25 Q 8 14, 12 2 Q 14 15, 15 25" />
                <path class="right-wing" d="M 15 25 Q 8 36, 12 48 Q 14 35, 15 25" />
                <path class="bird-body" d="M 5 25 C 8 22, 22 22, 25 25 C 22 28, 8 28, 5 25 Z" />
              </g>
            </svg>
            <svg class="morning-bird bird-2" viewBox="0 0 30 50">
              <g class="bird-body-group">
                <path class="left-wing" d="M 15 25 Q 8 14, 12 2 Q 14 15, 15 25" />
                <path class="right-wing" d="M 15 25 Q 8 36, 12 48 Q 14 35, 15 25" />
                <path class="bird-body" d="M 5 25 C 8 22, 22 22, 25 25 C 22 28, 8 28, 5 25 Z" />
              </g>
            </svg>
            <svg class="morning-bird bird-3" viewBox="0 0 30 50">
              <g class="bird-body-group">
                <path class="left-wing" d="M 15 25 Q 8 14, 12 2 Q 14 15, 15 25" />
                <path class="right-wing" d="M 15 25 Q 8 36, 12 48 Q 14 35, 15 25" />
                <path class="bird-body" d="M 5 25 C 8 22, 22 22, 25 25 C 22 28, 8 28, 5 25 Z" />
              </g>
            </svg>
            <!-- Floating morning dust particles -->
            <div class="dust-particle dp-1"></div>
            <div class="dust-particle dp-2"></div>
            <div class="dust-particle dp-3"></div>
            <div class="dust-particle dp-4"></div>
            <div class="dust-particle dp-5"></div>
            }

            <!-- Afternoon Sunlight / Lens Flare / Clouds / Pollen -->
            @if (greetingTheme === 'afternoon') {
            <div class="lens-flare"></div>
            <div class="sun-rays bright"></div>
            <div class="afternoon-cloud ac-1"></div>
            <div class="afternoon-cloud ac-2"></div>
            <div class="afternoon-cloud ac-3"></div>
            <div class="afternoon-cloud ac-4"></div>
            <div class="pollen-particle pp-1"></div>
            <div class="pollen-particle pp-2"></div>
            <div class="pollen-particle pp-3"></div>
            <div class="pollen-particle pp-4"></div>
            <div class="pollen-particle pp-5"></div>
            }

            <!-- Evening Sunset Glow / Clouds / Leaves / Glowing Particles -->
            @if (greetingTheme === 'evening') {
            <div class="sunset-glow"></div>
            <div class="evening-cloud ec-1"></div>
            <div class="evening-cloud ec-2"></div>
            <div class="glowing-particle gp-1"></div>
            <div class="glowing-particle gp-2"></div>
            <div class="glowing-particle gp-3"></div>
            <div class="glowing-particle gp-4"></div>
            <div class="glowing-particle gp-5"></div>
            <svg class="drifting-leaf lf-1" viewBox="0 0 24 24">
              <path
                d="M12,2 L13.5,6 L17.5,5 L16,8.5 L20.5,9 L17,12 L19.5,15.5 L14.5,14.5 L15,17.5 L12.7,18 L12.7,21 L11.3,21 L11.3,18 L9,17.5 L9.5,14.5 L4.5,15.5 L7,12 L3.5,9 L8,8.5 L6.5,5 L10.5,6 Z" />
            </svg>
            <svg class="drifting-leaf lf-2" viewBox="0 0 24 24">
              <path
                d="M12,2 L13.5,6 L17.5,5 L16,8.5 L20.5,9 L17,12 L19.5,15.5 L14.5,14.5 L15,17.5 L12.7,18 L12.7,21 L11.3,21 L11.3,18 L9,17.5 L9.5,14.5 L4.5,15.5 L7,12 L3.5,9 L8,8.5 L6.5,5 L10.5,6 Z" />
            </svg>
            <svg class="drifting-leaf lf-3" viewBox="0 0 24 24">
              <path
                d="M12,2 L13.5,6 L17.5,5 L16,8.5 L20.5,9 L17,12 L19.5,15.5 L14.5,14.5 L15,17.5 L12.7,18 L12.7,21 L11.3,21 L11.3,18 L9,17.5 L9.5,14.5 L4.5,15.5 L7,12 L3.5,9 L8,8.5 L6.5,5 L10.5,6 Z" />
            </svg>
            <svg class="drifting-leaf lf-4" viewBox="0 0 24 24">
              <path
                d="M12,2 L13.5,6 L17.5,5 L16,8.5 L20.5,9 L17,12 L19.5,15.5 L14.5,14.5 L15,17.5 L12.7,18 L12.7,21 L11.3,21 L11.3,18 L9,17.5 L9.5,14.5 L4.5,15.5 L7,12 L3.5,9 L8,8.5 L6.5,5 L10.5,6 Z" />
            </svg>
            <svg class="drifting-leaf lf-5" viewBox="0 0 24 24">
              <path
                d="M12,2 L13.5,6 L17.5,5 L16,8.5 L20.5,9 L17,12 L19.5,15.5 L14.5,14.5 L15,17.5 L12.7,18 L12.7,21 L11.3,21 L11.3,18 L9,17.5 L9.5,14.5 L4.5,15.5 L7,12 L3.5,9 L8,8.5 L6.5,5 L10.5,6 Z" />
            </svg>
            <svg class="drifting-leaf lf-6" viewBox="0 0 24 24">
              <path
                d="M12,2 L13.5,6 L17.5,5 L16,8.5 L20.5,9 L17,12 L19.5,15.5 L14.5,14.5 L15,17.5 L12.7,18 L12.7,21 L11.3,21 L11.3,18 L9,17.5 L9.5,14.5 L4.5,15.5 L7,12 L3.5,9 L8,8.5 L6.5,5 L10.5,6 Z" />
            </svg>
            <svg class="drifting-leaf lf-7" viewBox="0 0 24 24">
              <path
                d="M12,2 L13.5,6 L17.5,5 L16,8.5 L20.5,9 L17,12 L19.5,15.5 L14.5,14.5 L15,17.5 L12.7,18 L12.7,21 L11.3,21 L11.3,18 L9,17.5 L9.5,14.5 L4.5,15.5 L7,12 L3.5,9 L8,8.5 L6.5,5 L10.5,6 Z" />
            </svg>
            <svg class="drifting-leaf lf-8" viewBox="0 0 24 24">
              <path
                d="M12,2 L13.5,6 L17.5,5 L16,8.5 L20.5,9 L17,12 L19.5,15.5 L14.5,14.5 L15,17.5 L12.7,18 L12.7,21 L11.3,21 L11.3,18 L9,17.5 L9.5,14.5 L4.5,15.5 L7,12 L3.5,9 L8,8.5 L6.5,5 L10.5,6 Z" />
            </svg>
            <svg class="drifting-leaf lf-9" viewBox="0 0 24 24">
              <path
                d="M12,2 L13.5,6 L17.5,5 L16,8.5 L20.5,9 L17,12 L19.5,15.5 L14.5,14.5 L15,17.5 L12.7,18 L12.7,21 L11.3,21 L11.3,18 L9,17.5 L9.5,14.5 L4.5,15.5 L7,12 L3.5,9 L8,8.5 L6.5,5 L10.5,6 Z" />
            </svg>
            <svg class="drifting-leaf lf-10" viewBox="0 0 24 24">
              <path
                d="M12,2 L13.5,6 L17.5,5 L16,8.5 L20.5,9 L17,12 L19.5,15.5 L14.5,14.5 L15,17.5 L12.7,18 L12.7,21 L11.3,21 L11.3,18 L9,17.5 L9.5,14.5 L4.5,15.5 L7,12 L3.5,9 L8,8.5 L6.5,5 L10.5,6 Z" />
            </svg>
            }

            <!-- Night Stars / Moon / Fireflies / Shooting Star -->
            @if (greetingTheme === 'night') {
            <div class="night-sky-overlay"></div>
            <div class="night-cat-glow"></div>
            <div class="crescent-moon"></div>
            <!-- Sparkly/twinkling stars -->
            <div class="star-sparkle ss-1"></div>
            <div class="star-sparkle ss-2"></div>
            <div class="star-sparkle ss-3"></div>
            <div class="star-sparkle ss-4"></div>
            <div class="star-sparkle ss-5"></div>
            <!-- Fireflies -->
            <div class="firefly ff-1"></div>
            <div class="firefly ff-2"></div>
            <div class="firefly ff-3"></div>
            <div class="firefly ff-4"></div>
            <div class="firefly ff-5"></div>
            <!-- Shooting Star -->
            <div class="shooting-star"></div>
            }
          </div>
          <div class="banner-content">
            <h2 class="greeting-title">
              @if (greetingTheme === 'morning' || greetingTheme === 'evening') {
              <svg class="greeting-icon-svg greeting-icon theme-icon" viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg">
                <defs>
                  <clipPath id="horizon-clip">
                    <rect x="0" y="0" width="24" height="18" />
                  </clipPath>
                </defs>
                <g class="sun-group" clip-path="url(#horizon-clip)">
                  <!-- Semicircle sun -->
                  <path d="M 7.5 18 A 4.5 4.5 0 0 1 16.5 18" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" />
                  <!-- Top ray -->
                  <line x1="12" y1="11" x2="12" y2="7" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                  <!-- Left diagonal ray -->
                  <line x1="7" y1="13" x2="4.5" y2="10.5" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" />
                  <!-- Right diagonal ray -->
                  <line x1="17" y1="13" x2="19.5" y2="10.5" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" />
                </g>
                <!-- Horizon line -->
                <line class="horizon-line" x1="3" y1="18" x2="21" y2="18" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" />
              </svg>
              } @else {
              <span class="material-symbols-outlined greeting-icon">{{ greetingIcon }}</span>
              }
              {{ greeting }}, {{ userFirstName }}!
            </h2>
            <p class="greeting-subtitle">
              Welcome to Link, Your complete workspace to manage in one place.
            </p>

            <!-- Quotes Card -->
            <div class="quote-card">
              <span class="quote-decor-mark">“</span>
              <div class="quote-content-wrapper">
                <p class="quote-text">{{ currentQuote }}</p>
                @if (currentAuthor) {
                <div class="quote-footer">
                  <span class="quote-divider"></span>
                  <span class="quote-author">{{ currentAuthor }}</span>
                </div>
                }
              </div>
            </div>
          </div>

          <!-- Interactive Cat Illustration -->
          <div class="cat-animation-container">
            <svg class="interactive-cat-svg" viewBox="0 0 180 200" width="100%" height="100%"
              xmlns="http://www.w3.org/2000/svg">

              <defs>

                <radialGradient id="cat-body-grad" cx="35%" cy="30%" r="70%">
                  <stop offset="0%" stop-color="#2d251f" />
                  <stop offset="50%" stop-color="#18130e" />
                  <stop offset="100%" stop-color="#0a0705" />
                </radialGradient>

                <radialGradient id="cat-head-grad" cx="35%" cy="35%" r="75%">
                  <stop offset="0%" stop-color="#322921" />
                  <stop offset="45%" stop-color="#1a140f" />
                  <stop offset="100%" stop-color="#080604" />
                </radialGradient>

                <clipPath id="left-eye-clip">
                  <ellipse cx="70" cy="79" rx="15" ry="20" />
                </clipPath>

                <clipPath id="right-eye-clip">
                  <ellipse cx="113" cy="80" rx="15" ry="20" />
                </clipPath>

              </defs>

              <!-- SHADOW -->
              <ellipse class="cat-shadow" cx="92" cy="186" rx="42" ry="7" fill="rgba(0,0,0,.15)" />

              <!-- ENTIRE CAT WRAPPER -->
              <g class="cat-character">

                <!-- TAIL -->
                <path class="cat-tail" d="M 115 170 C 120 178, 130 178, 132 160
           C 134 142, 138 136, 150 136
           C 160 136, 162 144, 155 146" fill="none" stroke="#1a140f" stroke-width="13" stroke-linecap="round" />

                <!-- BODY -->
                <path class="cat-body" d="M 90 120
           C 60 140, 64 165, 64 170
           C 60 185, 125 180, 120 180
           C 130 160, 121 140, 108 120 Z" fill="url(#cat-body-grad)" />

                <!-- HEAD -->
                <g class="cat-head">

                  <!-- LEFT EAR -->
                  <path class="cat-ear-left" d="M 42 58
             C 39 42, 45 28, 54 26
             C 59 25, 63 27, 65 33
             C 67 40, 68 45, 68 48 Z" fill="url(#cat-head-grad)" />

                  <!-- RIGHT EAR -->
                  <path class="cat-ear-right" d="M 142 58
             C 145 42, 139 28, 130 26
             C 125 25, 121 27, 119 33
             C 117 40, 116 45, 116 48 Z" fill="url(#cat-head-grad)" />

                  <!-- HEAD BASE -->
                  <ellipse cx="92" cy="85" rx="64" ry="48" fill="url(#cat-head-grad)" />

                  <!-- LEFT WHISKERS -->
                  <g class="cat-whiskers-left">

                    <line x1="38" y1="92" x2="16" y2="90" stroke="#1a140f" stroke-width="3.5" stroke-linecap="round" />

                    <line x1="35" y1="100" x2="12" y2="100" stroke="#1a140f" stroke-width="3.5"
                      stroke-linecap="round" />

                    <line x1="38" y1="108" x2="16" y2="110" stroke="#1a140f" stroke-width="3.5"
                      stroke-linecap="round" />

                  </g>

                  <!-- RIGHT WHISKERS -->
                  <g class="cat-whiskers-right">

                    <line x1="146" y1="92" x2="168" y2="90" stroke="#1a140f" stroke-width="3.5"
                      stroke-linecap="round" />

                    <line x1="149" y1="100" x2="172" y2="100" stroke="#1a140f" stroke-width="3.5"
                      stroke-linecap="round" />

                    <line x1="146" y1="108" x2="168" y2="110" stroke="#1a140f" stroke-width="3.5"
                      stroke-linecap="round" />

                  </g>

                  <!-- EYES -->
                  <g class="cat-eyes-blink-group">

                    <ellipse cx="70" cy="79" rx="15" ry="20" fill="white" />

                    <g clip-path="url(#left-eye-clip)">
                      <ellipse class="cat-pupil-left" cx="70" cy="79" rx="5.5" ry="8" fill="#111" />
                    </g>

                    <ellipse cx="113" cy="80" rx="15" ry="20" fill="white" />

                    <g clip-path="url(#right-eye-clip)">
                      <ellipse class="cat-pupil-right" cx="113" cy="80" rx="5.5" ry="8" fill="#111" />
                    </g>

                  </g>

                  <!-- NOSE -->
                  <ellipse cx="92" cy="95" rx="5.5" ry="4" fill="#fbbf24" />

                </g>

              </g>

            </svg>
          </div>

          <!-- SVG Cloud Morph Filter definition -->
          <svg style="position: absolute; width: 0; height: 0; overflow: hidden;" width="0" height="0">
            <defs>
              <filter id="cloud-morph" x="-10%" y="-10%" width="120%" height="120%">
                <feTurbulence type="fractalNoise" baseFrequency="0.01 0.008" numOctaves="2" result="noise">
                  <animate attributeName="baseFrequency" dur="18s" values="0.008 0.006; 0.012 0.01; 0.008 0.006"
                    repeatCount="indefinite" />
                </feTurbulence>
                <feDisplacementMap in="SourceGraphic" in2="noise" scale="30" xChannelSelector="R" yChannelSelector="G">
                  <animate attributeName="scale" dur="14s" values="20; 40; 20" repeatCount="indefinite" />
                </feDisplacementMap>
              </filter>
            </defs>
          </svg>
        </div>

        <!-- Live News Section -->
        <div class="news-section-card">
          <div class="news-header">
            <div class="news-header-title">
              <span class="material-symbols-outlined news-header-icon">language</span>
              <span class="news-header-text">Link News</span>
            </div>
            <button class="news-refresh-btn" (click)="fetchNews()" [disabled]="isLoadingNews">
              <span class="material-symbols-outlined refresh-icon" [class.spinning]="isLoadingNews">refresh</span>
              Refresh
            </button>
          </div>

          <!-- Shimmer Loader -->
          @if (isLoadingNews && newsArticles.length === 0) {
          <div class="news-loading-shimmer">
            <div class="shimmer-card"></div>
            <div class="shimmer-card"></div>
            <div class="shimmer-card"></div>
          </div>
          } @else {
          <!-- Carousel Container -->
          <div class="news-carousel-container" (mouseenter)="stopAutoScroll()" (mouseleave)="startAutoScroll()">
            <!-- Previous Button -->
            <button class="nav-arrow prev" (click)="prevNews()" aria-label="Previous News">
              <span class="material-symbols-outlined">chevron_left</span>
            </button>

            <!-- Slider Wrapper -->
            <div class="news-slider-wrapper">
              <div class="news-track" [style.--active-index]="activeIndex">
                @for (article of newsArticles; track article) {
                <div class="news-card" (click)="openArticle(article.url)">
                  <img [src]="article.urlToImage" (error)="onNewsImageError(article)" class="news-card-bg"
                    alt="News Background" />
                  <!-- Top Badge/Source -->
                  <div class="news-source-badge" (mouseenter)="onSourceHover($event, article)"
                    (mouseleave)="onSourceLeave()">
                    <span>{{ article.source?.name || 'News' }}</span>
                    @if (showTooltipFor === article) {
                    <div class="custom-tooltip badge-tooltip">
                      {{ article.source?.name || 'News' }}
                    </div>
                    }
                  </div>

                  <!-- Content Overlay -->
                  <div class="news-card-overlay">
                    <div class="news-meta">
                      <span class="news-date">{{ formatNewsDate(article.publishedAt) }}</span>
                    </div>
                    <h4 class="news-title" (mouseenter)="onTitleHover($event, article)" (mouseleave)="onTitleLeave()">
                      {{ article.title }}
                      @if (showTitleTooltipFor === article) {
                      <div class="custom-tooltip title-tooltip">
                        {{ article.title }}
                      </div>
                      }
                    </h4>
                    <p class="news-desc">{{ article.description }}</p>
                  </div>
                </div>
                }
              </div>
            </div>

            <!-- Next Button -->
            <button class="nav-arrow next" (click)="nextNews()" aria-label="Next News">
              <span class="material-symbols-outlined">chevron_right</span>
            </button>
          </div>
          }
        </div>
      </div>

      <!-- Right Column: Live Stocks Card -->
      <div class="stocks-card-wrapper">
        <div class="stocks-card">
          <div class="stocks-header">
            <div class="stocks-header-title">
              <div class="stocks-header-icon-container">
                <span class="material-symbols-outlined stocks-header-icon">monitoring</span>
              </div>
              <span class="stocks-header-text">Live Stocks</span>
            </div>
            <button class="stocks-refresh-btn" (click)="refreshStocks()" [disabled]="isLoadingStocks">
              <span class="material-symbols-outlined refresh-icon" [class.spinning]="isLoadingStocks">refresh</span>
              Refresh
            </button>
          </div>

          <div class="stocks-list">
            @for (stock of stocks; track stock.symbol) {
            <div class="stock-item">
              <!-- Favourite Star Button -->
              <button class="favorite-btn" (click)="toggleFavourite(stock, $event)"
                [attr.aria-label]="stock.isFavourite ? 'Remove from favorites' : 'Add to favorites'">
                <span class="material-symbols-outlined" [class.filled]="stock.isFavourite">star</span>
              </button>

              <!-- Logo Container -->
              <div class="stock-logo-wrapper">
                @if (stock.logo) {
                <img [src]="stock.logo" class="stock-logo" alt="logo" (error)="stock.logo = ''" />
                } @else {
                @switch (stock.logoType) {
                @case ('amazon') {
                <svg class="stock-logo" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="24" height="24" rx="6" fill="#131921" />
                  <text x="6" y="16" fill="#ffffff" font-family="Arial, sans-serif" font-weight="bold"
                    font-size="12">a</text>
                  <path d="M 5.5,17 Q 10.5,20.5 15.5,17" stroke="#ff9900" stroke-width="1.8" fill="none"
                    stroke-linecap="round" />
                  <path d="M 13.8,17.8 L 16,16.8 L 15.2,19" fill="#ff9900" />
                </svg>
                }
                @case ('cocacola') {
                <svg class="stock-logo" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="24" height="24" rx="6" fill="#F40009" />
                  <!-- Simple representation of script letters KO -->
                  <text x="5" y="15" fill="#ffffff" font-family="Impact, sans-serif" font-weight="bold" font-size="9"
                    letter-spacing="1">KO</text>
                </svg>
                }
                @case ('ups') {
                <svg class="stock-logo" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L4 5V11C4 16.5 12 22 12 22C12 22 20 16.5 20 11V5L12 2Z" fill="#351c15" />
                  <path d="M12 2L4 5V7H20V5L12 2Z" fill="#ffb000" />
                  <text x="6.5" y="14" fill="#ffffff" font-family="Arial, sans-serif" font-weight="bold"
                    font-size="7">UPS</text>
                </svg>
                }
                @case ('mastercard') {
                <div class="stock-logo logo-mastercard">
                  <div class="circle red"></div>
                  <div class="circle yellow"></div>
                </div>
                }
                @case ('microsoft') {
                <div class="stock-logo logo-microsoft">
                  <div class="sq red"></div>
                  <div class="sq green"></div>
                  <div class="sq blue"></div>
                  <div class="sq yellow"></div>
                </div>
                }
                @case ('bmw') {
                <div class="stock-logo logo-bmw">
                  <div class="inner-circle">
                    <div class="quadrant q1 white"></div>
                    <div class="quadrant q2 blue"></div>
                    <div class="quadrant q3 white"></div>
                    <div class="quadrant q4 blue"></div>
                  </div>
                </div>
                }
                }
                }
              </div>

              <!-- Name & Symbol -->
              <div class="stock-info">
                <div class="stock-name" [title]="stock.name">{{ stock.name }}</div>
                <div class="stock-symbol">{{ stock.symbol }}</div>
              </div>

              <!-- Sparkline SVG -->
              <div class="stock-trend">
                <svg width="80" height="24" viewBox="0 0 80 24" class="sparkline-svg">
                  <defs>
                    <linearGradient [id]="'gradient-' + stock.symbol" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0%" [attr.stop-color]="stock.change >= 0 ? '#22c55e' : '#ef4444'"
                        stop-opacity="0.25" />
                      <stop offset="100%" [attr.stop-color]="stock.change >= 0 ? '#22c55e' : '#ef4444'"
                        stop-opacity="0" />
                    </linearGradient>
                  </defs>
                  @if (stock.areaPath && stock.linePath) {
                  <!-- Closed Area Path under the sparkline -->
                  <path [attr.d]="stock.areaPath" [attr.fill]="'url(#gradient-' + stock.symbol + ')'" />
                  <!-- Sparkline Line Path -->
                  <path [attr.d]="stock.linePath" [attr.stroke]="stock.change >= 0 ? '#22c55e' : '#ef4444'"
                    stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round" />
                  }
                </svg>
              </div>

              <!-- Price & Percentage Change -->
              <div class="stock-pricing" [class.negative]="stock.change < 0" [class.positive]="stock.change >= 0">
                <div class="stock-price">{{ stock.symbol.includes('.NS') ? '₹' : '$' }}{{ stock.price.toFixed(2) }}
                </div>
                <div class="stock-change">
                  {{ stock.change >= 0 ? '+' : '' }}{{ stock.change.toFixed(2) }}
                </div>
              </div>
            </div>
            }
          </div>
        </div>
      </div>
    </div>

    <!-- Search Section -->
    <div class="search-section">
      <div class="section-header">
        <h3 class="section-title">Workspace Modules</h3>
      </div>
      <div class="search-container">
        <div class="search-wrapper">
          <span class="material-symbols-outlined search-icon">search</span>
          <input type="text" placeholder="Search modules..." [(ngModel)]="searchQuery" class="search-input" />
        </div>
      </div>
    </div>

    <!-- Modules Grid -->
    <div class="modules-grid">
      @for (module of filteredModules; track module) {
      <div class="module-card-wrapper" (mouseenter)="onCardHover(module.id)" (mouseleave)="onCardLeave()"
        (click)="navigateToModule(module)">
        <div class="module-card" [class.hovered]="hoveredCard === module.id">
          <!-- Category Badge -->
          <div class="category-badge">
            <span class="category-text">{{ module.category }}</span>
            @if (isBeta(module.id)) { <span class="beta-tag">Beta</span> }
          </div>
          <!-- Icon -->
          <div class="icon-container gradient-{{ module.id }}" [class.icon-hovered]="hoveredCard === module.id">
            <span class="material-symbols-outlined">{{ getMaterialIcon(module.iconName) }}</span>
          </div>
          <!-- Content -->
          <h3 class="module-title">{{ module.title }}</h3>
          <p class="module-description">{{ module.description }}</p>
          <!-- Action Button -->
          <div class="action-button" [class.button-hovered]="hoveredCard === module.id">
            <span>Get Started</span>
            <span class="material-symbols-outlined chevron-icon">chevron_right</span>
          </div>
        </div>
        <!-- Gradient Border Effect on Hover -->
        <div class="gradient-border gradient-{{ module.id }}" [class.border-visible]="hoveredCard === module.id"></div>
      </div>
      }
    </div>

    <!-- Empty State -->
    @if (filteredModules.length === 0) {
    <div class="empty-state">
      <div class="empty-icon-container">
        <span class="material-symbols-outlined empty-icon">search</span>
      </div>
      <h3 class="empty-title">No modules found</h3>
      <p class="empty-description">Try adjusting your search query</p>
    </div>
    }
  </main>
</div>

<app-footer></app-footer>